module.exports = __webpack_public_path__ + "src/assets/img/slider_guy.5c7af6ed.png";